<template>
  <div class="user-organ">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item v-if="funcView.user_department_bind || !!orgId">
          <el-button type="primary" :disabled="!userId" icon="el-icon-plus" @click="openBindOrgan">
            {{ $t('base_user_organ.jia_ru_bu_men') }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.user_department_unbind || !!orgId">
          <el-button type="primary" icon="el-icon-minus" :disabled="!userId || !tableSelect.length" @click="unbindAllOrganConfirm">
            {{ $t('base_user_organ.tui_chu_bu_men') }}
          </el-button>
        </el-form-item>
        <!-- 配置表格列 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_user_organ.bu_men_ming_cheng')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格栏 -->
    <div class="table-bd">
      <custom-table type="checkbox" tableCode="user_organ" v-model="tableSelect" :data="organList" @column="setColumn" @filter="filterChange" @sort="sortChange">
        <el-table-column :label="$t('Common.com_handle')" fixed="right">
          <template slot-scope="scope" v-if="funcView.user_department_unbind || !!orgId">
            <el-button type="text" size="mini" @click="unbindOrganConfirm(scope.row)">
              {{ $t('base_user_organ.tui_chu') }}
            </el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 关联部门弹窗 -->
    <user-organ-bind-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getUserOrganPage()"></user-organ-bind-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import userOrganBindDialog from './user_organ_bind_dialog';

export default {
  components: { userOrganBindDialog },
  props: {
    userId: {
      type: [String, Number, Boolean],
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    orgId: [String, Number]
  },
  data() {
    return {
      tableSelect: [],
      dialogVisible: false,
      dialogModel: {},

      formSearch: {
        search: '',
        userId: '',
        pageSize: 50,
        pageNum: 1
      },

      organList: [],
      totalRows: 0,
      isLoading: false
    };
  },
  watch: {
    userId: function () {
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getUserOrganPage();
    }
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView('/company/user');
    this.getUserOrganPage();
  },
  methods: {
    // 获取用户组织列表(分页)
    getUserOrganPage: function () {
      if (!this.userId) {
        this.organList = [];
        this.totalRows = 0;
        return;
      }
      this.formSearch.userId = this.userId;
      this.$getJSON(apis.UserDepartmentPage, this.formSearch).then((res) => {
        this.organList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 关联组织弹窗
    openBindOrgan: function () {
      this.dialogModel.title = this.$t('base_user_organ.jia_ru_bu_men');
      this.dialogModel.data = { userId: this.userId, userName: this.userName, orgId: this.orgId };
      this.dialogVisible = true;
    },
    // 批量取消关联确认
    unbindAllOrganConfirm: function () {
      this.$showConfirm(this.$t('base_user_organ.nqdyjxzdyhtcxzdbm'))
        .then(() => {
          const ids = this.tableSelect.map(t => ({ bizId: t.bizId, bizType: t.bizType }));
          this.unbindOrgan({
            userId: this.userId,
            orgDepartments: ids
          });
        })
        .catch(() => {});
    },
    // 取消关联确认
    unbindOrganConfirm: function (item) {
      this.$showConfirm(this.$t('base_user_organ.nqdyjxzdyhtcxzdbm'))
        .then(() => {
          this.unbindOrgan({
            userId: this.userId,
            orgDepartments: [{ bizId: item.bizId, bizType: item.bizType }]
          });
        })
        .catch(() => {});
    },
    // 取消关联
    unbindOrgan: function (params) {
      this.$postJSON(apis.OrganUnbindbyUser, params).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.getUserOrganPage();
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getUserOrganPage();
    }
  }
};
</script>

<style lang="scss"></style>
